export default "<label class=\"fs-14 regular errorcolor\" >{{errorMsg}}</label>\n";